<app-emptyservices *ngIf="!contentReady && (noData || !tokenExists)"></app-emptyservices>

<app-loading *ngIf="contentReady"></app-loading>

<div
  class="addresses-container bg-light"
  *ngIf="!contentReady && !noData && tokenExists"
  style="margin-bottom: 70px;"
>

  <div class="order-card" *ngFor="let booking of allData; let isFirst = first">

    <div class="order-id" style="text-align: center;">

      <!-- Service Image -->
      <img
        src="/assets/e-commerce/icons/93.webp"
        alt="service"
        class="product-img"
      />

      <br>

      <!-- Status -->
      <span class="status" [ngClass]="getStatusClass(booking.status)">
        {{ getStatusLabel(booking.status) }}
      </span>

      <br><br>

      <!-- Booking Date -->
      {{ isAr ? "ميعاد الحجز" : "Booking Date" }}
      <div class="order-price">
        {{ convertDateTime(booking.booking_date) }}
      </div>

      <!-- Deferred Date -->
      <ng-container *ngIf="isDeferredBooking(booking)">
        <br>

        {{ isAr ? "ميعاد الحجز الجديد" : "New Booking Date" }}
        <div class="order-price deferred-date">
          {{ convertDateTime(booking.deferred_booking_date) }}
        </div>
      </ng-container>

      <br>

      <!-- Booking Number -->
      {{ isAr ? "رقم الحجز" : "Booking Number" }}
      <div class="order-price">
        #{{ booking.id }}
      </div>

      <br>

      <!-- Service Name -->
      {{ isAr ? "الخدمة" : "Service" }}
      <div class="order-price service-title">
        {{ getServiceName(booking) }}
      </div>

      <br>

      <!-- Price -->
      <ng-container *ngIf="getServicePrice(booking)">
        {{ "total" | transloco }}
        <div class="order-price">
          {{ getServicePrice(booking) }} {{ "egpe" | transloco }}
        </div>
        <br>
      </ng-container>

      <!-- Booking Info Box -->
      <!-- <div class="booking-info-box">

        <div class="booking-info-row">
          <span>{{ isAr ? "نوع الحيوان" : "Pet Type" }}</span>
          <strong>{{ getPetTypeLabel(booking.pet_type) }}</strong>
        </div>

        <div class="booking-info-row">
          <span>{{ isAr ? "اسم العميل" : "Client Name" }}</span>
          <strong>{{ booking.client_name || "-" }}</strong>
        </div>

        <div class="booking-info-row">
          <span>{{ isAr ? "رقم الهاتف" : "Phone" }}</span>
          <strong>{{ booking.phone_number || "-" }}</strong>
        </div>

        <div class="booking-info-row" *ngIf="booking.from_website">
          <span>{{ isAr ? "مصدر الحجز" : "Source" }}</span>
          <strong>{{ booking.from_website }}</strong>
        </div>

      </div> -->

    </div>

    <!-- Actions -->
    <div class="order-actions" style="text-align: center;">
      <br>

      <span class="status status-call pointer" (click)="callClinic()">
        {{ isAr ? "اتصال بالعيادة" : "Call Clinic" }}
      </span>

      <span class="status status-approved pointer" (click)="chatClinic()">
        {{ isAr ? "واتساب" : "WhatsApp" }}
      </span>

      <span
        class="status status-rejected pointer"
        *ngIf="canCancelBooking(booking)"
        (click)="cancelBooking(booking.id)"
      >
        {{ isAr ? "إلغاء الحجز" : "Cancel Booking" }}
      </span>

    </div>

  </div>

</div>